import { connect } from 'react-redux'
import get from 'lodash/get'
import {
  branch,
  compose,
  renderNothing,
  withProps,
  withStateHandlers,
} from 'recompose'
import { injectIntl } from 'react-intl'
import { LearnMore } from '../../../constants/trackingEvents'
import { withElementRef } from '../../../composables'
import { scrollToElement } from '../../../helpers/browser'
import { getRef } from '../../../store/elementReference'
import {
  selectLeverageableEquityForLTV,
  CASHOUT_LTV,
  CASHOUT_MINIMUM,
} from '../../../store/selectors/home/equity'
import { dispatchEvent } from '../../../helpers/tagManager'

const PURCHASING_POWER_LTV = 0.75
const PURCHASING_POWER_MINIMUM = 10000

const withLeverageableEquityForLTV = targetLTV =>
  connect(state => ({
    leverageableEquity: selectLeverageableEquityForLTV(targetLTV)(state),
  }))

const withMinLeverageableEquity = minimum =>
  branch(
    ({ leverageableEquity }) => {
      const leverageableEquityTwoDecimals =
        Math.round(leverageableEquity * 100) / 100
      return leverageableEquityTwoDecimals < minimum
    }, // TODO: duplicated logic in selectShouldRenderCashout (Cashout also uses ifRefiEligible but not Purchasing Power)
    renderNothing
  )

const withSelectionState = compose(
  withStateHandlers(
    { selectedId: 0, showDetail: false },
    {
      show:
        (state, { gems, cardRef, padding }) =>
        id => {
          dispatchEvent(LearnMore, {
            eventLabel: get(gems, [id, 'key']),
          })

          const { current: ref } = getRef(cardRef)
          scrollToElement(ref, { padding })

          return {
            selectedId: id,
            showDetail: true,
          }
        },
      hide: () => () => ({ showDetail: false }),
    }
  ),
  withProps(({ gems, defaultDM, showDetail, selectedId }) => {
    const selectedGem = gems[selectedId]
    const { question, topic } = showDetail ? selectedGem : defaultDM

    return {
      selectedGem,
      selectedDetail: selectedGem.Detail,
      question,
      topic,
    }
  })
)

const withMinimumEquityAndGemDisplayProps = ({
  gems,
  defaultDM,
  cardRef,
  padding,
  ltv,
  minimum,
}) =>
  compose(
    withLeverageableEquityForLTV(ltv),
    withMinLeverageableEquity(minimum),
    injectIntl,
    withProps({ gems, defaultDM, cardRef, padding }),
    withSelectionState,
    withElementRef(cardRef)
  )

const withPurchasePowerProps = ({ gems, defaultDM, cardRef, padding }) =>
  withMinimumEquityAndGemDisplayProps({
    gems,
    defaultDM,
    cardRef,
    padding,
    ltv: PURCHASING_POWER_LTV,
    minimum: PURCHASING_POWER_MINIMUM,
  })

const withCashOutProps = ({ gems, defaultDM, cardRef, padding }) =>
  withMinimumEquityAndGemDisplayProps({
    gems,
    defaultDM,
    cardRef,
    padding,
    ltv: CASHOUT_LTV,
    minimum: CASHOUT_MINIMUM,
  })

export { withPurchasePowerProps, withCashOutProps }
